
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { ArrowUpIcon } from "@/icons"
import { Metadata } from "next"
import { useTranslate } from "@tolgee/react"
import { getTranslate } from "@/tolgee/server"

export const metadata: Metadata = {
  title: "404",
  description: "Something went wrong",
}

export default async function NotFound() {
  const  t  = await  getTranslate()
  return (
    <div className="flex flex-col gap-4 items-center justify-center py-24">
      <h1 className="text-2xl-semi text-ui-fg-base">{t("not_found.page_not_found")}</h1>
      <p className="text-small-regular text-ui-fg-base">
        {t("not_found.page_does_not_exist")}
      </p>
      <LocalizedClientLink className="flex gap-x-1 items-center group" href="/">
        {t("not_found.go_to_frontpage")}
        <ArrowUpIcon
          className="group-hover:rotate-45 ease-in-out duration-150"
          color="var(--fg-interactive)"
        />
      </LocalizedClientLink>
    </div>
  )
}

export async function generateMetadata(): Promise<Metadata> {
 const  t  = await  getTranslate()
  return {
    title: t("not_found.title"),
    description: t("not_found.description"),
  }
}
